import { useContext, useState } from "react";
import { Button } from "components/atoms/Button";
import { ButtonType } from "components/atoms/Button/types";
import { Modal } from "components/atoms/Modal/index";
import { AppContext } from "lib/contexts";
import { Span, Title } from "utils/styling/typography.styled";
import { ButtonContainer, FormGroup, Label, ModalContainer, PremiumFormGroup, TextArea, ToggleSwitch } from "./EditModal.styled";
interface EditModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSubmit: (editRequest: string, isPremium: boolean) => void;
}
export const EditModal: React.FC<EditModalProps> = ({
  isOpen,
  onCancel,
  onSubmit
}) => {
  const {
    state
  } = useContext(AppContext);
  const [description, setDescription] = useState<string>("");
  const [isPremium, setIsPremium] = useState<boolean>(false);
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(e.target.value);
  };
  const handlePremiumToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsPremium(e.target.checked);
  };
  const handleSubmit = () => {
    onSubmit(description, isPremium);
  };
  return <Modal open={isOpen} handleBackdropClick={onCancel} disableBackdropClick data-sentry-element="Modal" data-sentry-component="EditModal" data-sentry-source-file="index.tsx">
            <ModalContainer data-sentry-element="ModalContainer" data-sentry-source-file="index.tsx">
                <Title data-sentry-element="Title" data-sentry-source-file="index.tsx">Edit Image</Title>
                <hr />
                <FormGroup data-sentry-element="FormGroup" data-sentry-source-file="index.tsx">
                    <Label htmlFor="description" data-sentry-element="Label" data-sentry-source-file="index.tsx">Edit Description:</Label>
                    <TextArea id="description" name="description" value={description} onChange={handleDescriptionChange} placeholder="Enter a detailed description of the changes you want to make to the image." data-sentry-element="TextArea" data-sentry-source-file="index.tsx" />
                </FormGroup>
                <PremiumFormGroup data-sentry-element="PremiumFormGroup" data-sentry-source-file="index.tsx">
                    <Label htmlFor="premiumToggle" data-sentry-element="Label" data-sentry-source-file="index.tsx">Premium Edit:</Label>
                    <ToggleSwitch data-sentry-element="ToggleSwitch" data-sentry-source-file="index.tsx">
                        <input id="premiumToggle" type="checkbox" checked={isPremium && !!state.credits} onChange={handlePremiumToggle} disabled={!state.credits} />
                        <span className="slider round"></span>
                    </ToggleSwitch>
                </PremiumFormGroup>
                <ButtonContainer data-sentry-element="ButtonContainer" data-sentry-source-file="index.tsx">
                    <Button type="button" variant={ButtonType.SUCCESS} onClick={handleSubmit} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Submit</Span>
                    </Button>
                    <Button type="button" variant={ButtonType.PRIMARY} onClick={onCancel} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Cancel</Span>
                    </Button>
                </ButtonContainer>
            </ModalContainer>
        </Modal>;
};